<template>
  <Sheet>
    <template #leading>
      <Sheet.Button :icon="CloseIcon" @click="close()" />
    </template>
    <template #title>{{ title }}</template>

    <Sheet.Body>
      <IAPBody :type="type" />
    </Sheet.Body>

    <div
      class="flex shrink-0 flex-col px-4 pt-2 pb-[calc(env(safe-area-inset-bottom)+16px)]"
    >
      <Button variant="primary" size="lg" @click="close()">Okay</Button>
    </div>
  </Sheet>
</template>

<script setup lang="ts">
import { Sheet, Button, useSheet } from '@dacr/library'
import { CloseIcon } from '@dacr/icons'

import IAPBody from './IAPBody.vue'
import { useIAP, type IAPType } from './useIAP'

const props = defineProps<{
  type: IAPType
}>()

const { close } = useSheet()
const { title } = useIAP(props.type)
</script>
